import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);
const KEY = "theratec_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.slug === product.slug);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + qty };
        return next;
      }
      return [...prev, {
        slug: product.slug,
        name: product.name,
        price: product.price,
        image: product.image,
        category: product.category,
        quantity: qty,
      }];
    });
    setOpen(true);
  };

  const remove = (slug) => setItems((prev) => prev.filter((i) => i.slug !== slug));
  const updateQty = (slug, q) => setItems((prev) => prev.map((i) => i.slug === slug ? { ...i, quantity: Math.max(1, q) } : i));
  const clear = () => setItems([]);

  const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartCtx.Provider value={{ items, add, remove, updateQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
